import Head from 'next/head';
import NextLink from 'next/link';
import { useRouter } from 'next/router';
import type { ReactNode } from 'react';

import { Tabs, TabsList, TabsTrigger } from '@/components/ui/tabs';

import AccessDenied from '@/components/auth/AccessDenied';
import LoginPrompt from '@/components/auth/LoginPrompt';

type ManagementLayoutProps = {
  isAuthenticated: boolean;
  hasAccess: boolean;
  isAdmin: boolean;
  children: ReactNode;
};

const ManagementLayout = ({
  isAuthenticated,
  hasAccess,
  isAdmin,
  children,
}: ManagementLayoutProps) => {
  const router = useRouter();
  const currentTab = router.pathname.split('/')[2] ?? 'teilnehmer';

  if (!isAuthenticated) {
    return (
      <>
        <Head>
          <title>Verwaltung</title>
        </Head>

        <div className="flex h-full items-center justify-center">
          <LoginPrompt />
        </div>
      </>
    );
  }

  if (!hasAccess) {
    return (
      <>
        <Head>
          <title>Verwaltung</title>
        </Head>

        <div className="flex h-full items-center justify-center">
          <AccessDenied />
        </div>
      </>
    );
  }

  return (
    <>
      <Head>
        <title>Verwaltung</title>
      </Head>

      <h1 className="mb-4 text-3xl font-semibold tracking-tight">Verwaltung</h1>
      <Tabs value={currentTab}>
        <TabsList>
          <TabsTrigger value="teilnehmer" asChild>
            <NextLink href="/verwaltung/teilnehmer">Teilnehmer</NextLink>
          </TabsTrigger>
          <TabsTrigger value="sponsoren" asChild>
            <NextLink href="/verwaltung/sponsoren">Sponsoren</NextLink>
          </TabsTrigger>
          <TabsTrigger value="zahlungen" asChild>
            <NextLink href="/verwaltung/zahlungen">Zahlungen</NextLink>
          </TabsTrigger>
          {isAdmin && (
            <TabsTrigger value="checkpoints" asChild>
              <NextLink href="/verwaltung/checkpoints">Checkpoints</NextLink>
            </TabsTrigger>
          )}
          {isAdmin && (
            <TabsTrigger value="benutzer" asChild>
              <NextLink href="/verwaltung/benutzer">Benutzer</NextLink>
            </TabsTrigger>
          )}
          {isAdmin && (
            <TabsTrigger value="gruppen" asChild>
              <NextLink href="/verwaltung/gruppen">Gruppen</NextLink>
            </TabsTrigger>
          )}
        </TabsList>

        <div className="mt-2 py-4">{children}</div>
      </Tabs>
    </>
  );
};

export default ManagementLayout;
